"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveTargetFieldSlug = exports.withTargetField = void 0;
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const fields_1 = require("./fields");
const registry_helpers_1 = require("../field-type-registry/registry-helpers");
const isEmpty_1 = __importDefault(require("lodash-es/isEmpty"));
/**
 * Get the target field for the field, and use it to calculate some property.
 *
 * @param field - App field
 * @param defaultValue - Default value to return if there is no target.
 * @param callback - Function to run on the target field.
 */
const withTargetField = (field, defaultValue, callback) => {
    var _a;
    let targetField = (_a = field === null || field === void 0 ? void 0 : field.params) === null || _a === void 0 ? void 0 : _a.target_field_structure;
    if ((0, isEmpty_1.default)(targetField)) {
        return defaultValue;
    }
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(targetField.field_type);
    if (!fieldLogic)
        return defaultValue;
    targetField = (0, registry_helpers_1.fillFieldDataFromRegistry)([targetField])[0];
    return callback(targetField, fieldLogic);
};
exports.withTargetField = withTargetField;
/**
 * Get target field slug.
 *
 * In case we have nested fields we need to return nested field slug,
 * in this case we will be able to get correct data from the record.
 * Otherwise, use target field slug.
 *
 * @param field  application field.
 * @param targetField  application target field.
 * @param slug  application structure field slug.
 */
const retrieveTargetFieldSlug = (field, targetField, slug) => {
    const [, nested] = (0, fields_1.resolveFieldBySlug)([field], slug);
    const targetFieldSlug = nested
        ? `${targetField.slug}.${nested.slug}`
        : targetField.slug;
    return [targetFieldSlug, nested];
};
exports.retrieveTargetFieldSlug = retrieveTargetFieldSlug;
